import {checkMenuDataItem} from './menu'


export const usedId = 'markAllAsUsed'
export const usedText = 'Mark all as "Used"'

export const unusedId = 'markAllAsUnused'
export const unusedText = 'Mark all as "Unused"'

export const readyForUseId = 'markAllAsReadyForUse'
export const readyForUseText = 'Mark all as "Ready for use"'


export const checkedUsedId = 'markCheckedAsUsed'
export const checkedUsedText = 'Mark all as "Used"'

export const checkedUnusedId = 'markCheckedAsUnused'
export const checkedUnusedText = 'Mark all as "Unused"'

export const checkedReadyForUseId = 'markCheckedAsReadyForUse'
export const checkedReadyForUseText = 'Mark all as "Ready for use"'


export const hideCheckedAnswersId = 'hideCheckedsAnswers'
export const hideCheckedAnswersText = 'Hide'

export const showCheckedAnswersId = 'showCheckedsAnswers'
export const showCheckedAnswersText = 'Show'

export const hideCheckedExplanationId = 'hideCheckedsExplanations'
export const hideCheckedExplanationText = 'Hide'

export const showCheckedExplanationId = 'showCheckedsExplanations'
export const showCheckedExplanationText = 'Show'


export const questionsId = 'questions'
export const subjectId = 'subject'
export const categoriesId = 'categories'
export const categoriesAnswersId = 'categoriesAnswers'
export const categoriesExplanationsId = 'categoriesExplanations'

const hasSubjectCheckCB = (hasSubject, hasQuestions) => !!hasSubject
const hasQuestionsCheckCB = (hasSubject, hasQuestions) => !!hasQuestions

export const questionsMenuData = {
    [questionsId] : {
        id : questionsId,
        text: "Questions",
        submenus: {
            [subjectId] : {
                id : subjectId,
                text : "Subject",
                checkCB : hasSubjectCheckCB,
                submenus : {
                    [usedId] : {
                        id : usedId,
                        text : usedText,
                        className : "submenu--danger",
                        checkCB : hasSubjectCheckCB,
                    },
                    [unusedId] : {
                        id : unusedId,
                        text : unusedText,
                        className : "submenu--white",
                        checkCB : hasSubjectCheckCB,
                    },
                    [readyForUseId] : {
                        id : readyForUseId,
                        text : readyForUseText,
                        className : "submenu--success",
                        checkCB : hasSubjectCheckCB,
                    },
                }
            },
            [categoriesId] : {
                id : categoriesId,
                text : "Categories",
                checkCB : hasQuestionsCheckCB,
                submenus : {
                    [checkedUsedId] : {
                        id : checkedUsedId,
                        text : checkedUsedText,
                        className : "submenu--danger",
                        checkCB : hasQuestionsCheckCB,
                    },
                    [checkedUnusedId] : {
                        id : checkedUnusedId,
                        text : checkedUnusedText,
                        className : "submenu--white",
                        checkCB : hasQuestionsCheckCB,
                    },
                    [checkedReadyForUseId] : {
                        id : checkedReadyForUseId,
                        text : checkedReadyForUseText,
                        className : "submenu--success",
                        checkCB : hasQuestionsCheckCB,
                    },
                    [categoriesAnswersId] : {
                        id : categoriesAnswersId,
                        text : "Answers",
                        submenus : {
                            [hideCheckedAnswersId] : {
                                id : hideCheckedAnswersId,
                                text : hideCheckedAnswersText,
                                checkCB : hasQuestionsCheckCB,
                            },
                            [showCheckedAnswersId] : {
                                id : showCheckedAnswersId,
                                text : showCheckedAnswersText,
                                checkCB : hasQuestionsCheckCB,
                            },
                        }
                    },
                    [categoriesExplanationsId] : {
                        id : categoriesExplanationsId,
                        text : "Explanations",
                        submenus : {
                            [hideCheckedExplanationId] : {
                                id : hideCheckedExplanationId,
                                text : hideCheckedExplanationText,
                                checkCB : hasQuestionsCheckCB,
                            },
                            [showCheckedExplanationId] : {
                                id : showCheckedExplanationId,
                                text : showCheckedExplanationText,
                                checkCB : hasQuestionsCheckCB,
                            },
                        }
                    }
                }
            },
        }
    }
}

export const getConfirmationText = submenuId => {
    switch (submenuId) {
        case usedId : {
            return 'Do you really want to change status of all questions in selected subject to "Used"?'
            break
        }
        case unusedId : {
            return 'Do you really want to change status of all questions in selected subject to "Unused"?'
            break
        }
        case readyForUseId : {
            return 'Do you really want to change status of all questions in selected subject to "Ready for use"?'
            break
        }
        case checkedUsedId : {
            return 'Do you really want to change status of all questions in selected category(ies) to "Used"?'
            break
        }
        case checkedUnusedId : {
            return 'Do you really want to change status of all questions in selected category(ies) to "Unused"?'
            break
        }
        case checkedReadyForUseId : {
            return 'Do you really want to change status of all questions in selected category(ies) to "Ready for use"?'
            break
        }
        case hideCheckedAnswersId : {
            return 'Do you really want to hide answers of all questions in selected category(ies)?'
            break
        }
        case showCheckedAnswersId : {
            return 'Do you really want to show answers of all questions in selected category(ies)?'
            break
        }
        case hideCheckedExplanationId : {
            return 'Do you really want to hide explanations of all questions in selected category(ies)?'
            break
        }
        case showCheckedExplanationId : {
            return 'Do you really want to show explanations of all questions in selected category(ies)?'
            break
        }
        default : {
            return ""
            break
        }
    }
}

export const getSuccesMsg = submenuId => {
    switch (submenuId) {
        case usedId :
        case unusedId :
        case readyForUseId :
        case checkedUsedId :
        case checkedUnusedId :
        case checkedReadyForUseId : {
            return "Status was successfully changed."
            break
        }
        case hideCheckedAnswersId : {
            return 'Answers are hide now.'
            break
        }
        case showCheckedAnswersId : {
            return 'Answers are shown now.'
            break
        }
        case hideCheckedExplanationId : {
            return 'Explanations are hide now.'
            break
        }
        case showCheckedExplanationId : {
            return 'Explanations are shown now.'
            break
        }
        default : {
            return ""
            break
        }
    }
}



export const checkQuestionsMenuDataItem = (...args) => {
    return checkMenuDataItem(questionsMenuData)(...args)
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/helpers/questionsMenu.js